/**
 * Booking Modal - Optimized for Instant Loading
 * Intercepts Acuity booking links and opens them in a modal
 */

(function() {
  'use strict';
  
  // Modal HTML
  const modalHTML = `
    <div class="booking-modal-overlay">
      <div class="booking-modal">
        <div class="booking-modal-header">
          <h2>Book an Appointment</h2>
          <button class="booking-modal-close" aria-label="Close">
            <svg viewBox="0 0 24 24">
              <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
            </svg>
          </button>
        </div>
        <div class="booking-modal-body"></div>
      </div>
    </div>
  `;
  
  let modal, modalBody, closeBtn;
  
  function init() {
    // Create modal
    const div = document.createElement('div');
    div.innerHTML = modalHTML;
    modal = div.firstElementChild;
    document.body.appendChild(modal);
    
    modalBody = modal.querySelector('.booking-modal-body');
    closeBtn = modal.querySelector('.booking-modal-close');
    
    // Close handlers
    closeBtn.addEventListener('click', closeModal);
    modal.addEventListener('click', function(e) {
      if (e.target === modal) closeModal();
    });
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && modal.classList.contains('active')) {
        closeModal();
      }
    });
    
    // Intercept clicks on booking links
    document.addEventListener('click', function(e) {
      const link = e.target.closest('a');
      if (link && link.href && link.href.includes('app.acuityscheduling.com/schedule/94d9a72b')) {
        e.preventDefault();
        e.stopPropagation();
        openModal(link.href);
      }
    }, true); // Capture phase
  }
  
  function openModal(url) {
    // Show modal
    modal.classList.add('active');
    document.body.classList.add('booking-modal-open');
    
    // Create and load iframe immediately (no loading spinner, no delay)
    const iframe = document.createElement('iframe');
    iframe.className = 'booking-modal-iframe';
    iframe.src = url;
    iframe.setAttribute('allowfullscreen', '');
    
    // Clear and add iframe immediately
    modalBody.innerHTML = '';
    modalBody.appendChild(iframe);
  }
  
  function closeModal() {
    modal.classList.remove('active');
    document.body.classList.remove('booking-modal-open');
    // Clear iframe on close to reset state
    setTimeout(function() {
      if (!modal.classList.contains('active')) {
        modalBody.innerHTML = '';
      }
    }, 300); // After transition
  }
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
